module.exports = __webpack_public_path__ + "img/PorscheCarrera300x300.db728647.jpg";